import { buildMakeUseAxios } from "@api";
import type { IPlace } from "@bbj-types/address";
import type { IPlacesQuery } from "@inputs/autocomplete/AutocompletePlacesUniq/logics";
import { useCallback } from "react";

const axios = buildMakeUseAxios(`${import.meta.env.VITE_TRANSPORT_SERVICE_URL}`);

export const useGetPlaces = () => {
  const [state, execute, cancel] = axios<{ data: IPlace[] }, Partial<Omit<IPlace, "_id">>, unknown>(
    {
      url: "/transport/places",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (filters: IPlacesQuery) => {
      return execute({
        url: "/transport/places",
        params: filters,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export * from "./getIsQPV";
